import { Modal, Input, Form, Button } from "antd";
import { useEffect, useState } from "react";

/** Collapse blank lines in profile / Home Hero description. */
export function sanitizeBioDescription(text: string): string {
  let out = String(text || "").replace(/\r\n/g, "\n");
  // Repeat until stable — one global replace leaves gaps for 3+ newlines.
  while (/\n\s*\n/.test(out)) {
    out = out.replace(/\n\s*\n/g, "\n");
  }
  return out.trim();
}

const EditBio = ({
  visible,
  onClose,
  onSubmit,
  initialValue,
  refetch,
  from,
  setName,
  setDescription,
}: any) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);
  useEffect(() => {
    if (visible) {
      form.setFieldsValue(initialValue);
    }
  }, [visible, initialValue, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const sanitizedValues = {
        ...values,
        name: typeof values?.name === "string" ? values.name.trim() : "",
        description:
          typeof values?.description === "string"
            ? sanitizeBioDescription(values.description)
            : "",
      };
      setConfirmLoading(true);
      await onSubmit(sanitizedValues);
      if (from === "review") {
        refetch();
        setName(sanitizedValues.name);
        setDescription(sanitizedValues.description);
      }
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Validation Failed:", error);
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Edit Profile"
      open={visible}
      data-testid="edit-profile-modal"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={handleOk}
          loading={confirmLoading}
        >
          Save
        </Button>,
      ]}
      // focusTriggerAfterClose={false}
      // getContainer={false}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValue}
      >
        <Form.Item
          label="Name"
          name="name"
          className="fontsize-12"
          rules={[
            { required: true, message: "Please enter the name!" },
            { max: 130, message: "Name must be 130 characters or less" },
            {
              validator: (_, value) => {
                if (value && typeof value === "string" && !value.trim()) {
                  return Promise.reject(new Error("Name cannot be only spaces"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Enter name" maxLength={130} showCount />
        </Form.Item>
        <Form.Item label="Description" name="description" className="fontsize-12">
          <Input.TextArea placeholder="Enter description" rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditBio;
